import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../translations';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { language } = useLanguage();
  const t = getTranslation(language);
  const location = useLocation();
  const navigate = useNavigate();
  
  const handleNavClick = (e, sectionId) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const handleContactClick = (e) => {
    e.preventDefault();
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo">
              <img src="/logo.png" alt="Agentecfusion" className="logo-image" />
              {language === 'en' ? (
                <img src="/logo_wordmark_white.png" alt="Agentecfusion" className="logo-wordmark" />
              ) : (
                <span>Agentecfusion</span>
              )}
            </div>
            <a 
              href="https://www.linkedin.com/company/agentecfusion/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer-linkedin"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
              linkedin.com/company/agentecfusion
            </a>
            <p className="footer-tagline">
              {t.footer.tagline}
            </p>
            <p className="footer-description">
              {t.footer.description}
            </p>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h4>{t.footer.product.title}</h4>
              <a href="/#capabilities" onClick={(e) => handleNavClick(e, 'capabilities')}>{t.footer.product.capabilities}</a>
              <a href="/#solutions" onClick={(e) => handleNavClick(e, 'solutions')}>{t.footer.product.applications}</a>
              <a href="/#platform" onClick={(e) => handleNavClick(e, 'platform')}>{t.footer.product.platform}</a>
              <a href="/one/">{language === 'en' ? 'Account center' : '账户中心'}</a>
            </div>

            <div className="footer-column">
              <h4>{t.footer.company.title}</h4>
              <a href="/about">{t.footer.company.about}</a>
              <a href="#contact" onClick={handleContactClick}>{t.footer.company.contact}</a>
              <a href="/one/admin">{language === 'en' ? 'Administration' : '管理后台'}</a>
            </div>

            <div className="footer-column">
              <h4>{t.footer.legal.title}</h4>
              <a href="/privacy">{t.footer.legal.privacy}</a>
              <a href="/terms">{t.footer.legal.terms}</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            {t.footer.copyright.replace('2025', currentYear)}
          </p>
          <div className="footer-contact">
            <a href="mailto:jinhuqi@agentecfusion.com">jinhuqi@agentecfusion.com</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
